import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

// Assets
import heroImage from "../assets/hero-image.png";
import missionImage from "../assets/mission-image.png";
import service1 from "../assets/service-1.png";
import service2 from "../assets/service-2.png";
import service3 from "../assets/service-3.png";
import service4 from "../assets/service-4.png";
import member1 from "../assets/member-1.png";
import member2 from "../assets/member-2.png";
import vision from "../assets/vision.jpg";
import client1 from "../assets/clien-1.jpg";
import client2 from "../assets/clien-2.jpg";
import contact from "../assets/contacts.jpg";

const services = [service1, service2, service3, service4];
const clients = [client1, client2];

const styles = {
  fonts: {
    title: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    body: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  },
  colors: {
    primary: "#76A9BA",
    secondary: "#345D63",
    grayish: "#666666",
    blackish: "#111B1C",
    accent: "#C2E6E1",
  },
  gradients: {
    left: "linear-gradient(to bottom, #345D63, #76A9BA)",
    sideLeft: "linear-gradient(to left, #345D63, #76A9BA)",
    top: "linear-gradient(to top, #345D63, #76A9BA)",
    right: "linear-gradient(to bottom, #1E3A8A, #0891B2)",
  },
};

const sections = [
  { id: "welcome", label: "Home" },
  { id: "mission", label: "Missione" },
  { id: "services", label: "Servizi" },
  { id: "vision", label: "Visione" },
  { id: "team", label: "Chi siamo" },
  { id: "label", label: "Private label" },
  { id: "contact", label: "Contatti" },
];

const Ball = ({ number }) => (
  <div
    className="flex items-center justify-center text-white font-bold text-sm aspect-square w-10 min-w-10 rounded-full leading-none mr-4"
    style={{ backgroundColor: styles.colors.secondary }}
  >
    {String(number).padStart(2, "0")}
  </div>
);

const ResponsiveText = ({ text, isTitle = false }) => (
  <p
    className={isTitle ? "text-xl sm:text-2xl md:text-3xl lg:text-4xl" : "text-base sm:text-lg md:text-xl leading-relaxed"}
    style={{
      fontFamily: isTitle ? styles.fonts.title : styles.fonts.body,
      color: isTitle ? styles.colors.blackish : styles.colors.grayish,
      lineHeight: 1.6,
    }}
  >
    {text}
  </p>
);


const LandingPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="font-sans text-gray-800 overflow-x-hidden overflow-y-auto">
      {/* HEADER */}
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 50,
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          padding: "1rem 1.5rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontFamily: styles.fonts.title,
            fontSize: "1.25rem",
            fontWeight: 600,
            color: styles.colors.secondary,
            letterSpacing: "0.05em",
          }}
        >
          OEM TECS
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6 text-sm md:text-base" style={{ fontFamily: styles.fonts.body }}>
          {sections.map(({ id, label }) => (
            <li key={id}>
              <Link
                to={id}
                smooth={true}
                duration={500}
                // offset={-100} 
                className="cursor-pointer relative transition"
                style={{ color: styles.colors.grayish }}
                onMouseEnter={(e) => (e.target.style.color = styles.colors.primary)}
                onMouseLeave={(e) => (e.target.style.color = styles.colors.grayish)}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile menu toggle */}
        <div
          className="md:hidden z-50"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ cursor: "pointer" }}
        >
          <div className="space-y-1">
            {[...Array(3)].map((_, i) => (
              <span
                key={i}
                style={{
                  display: "block",
                  width: "1.5rem",
                  height: "2px",
                  backgroundColor: styles.colors.blackish,
                }}
              />
            ))}
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <ul
            className="absolute top-full left-0 w-full md:hidden flex flex-col items-center py-4 space-y-4 shadow-lg border-t"
            style={{ backgroundColor: "#fff", fontFamily: styles.fonts.body }}
          >
            {sections.map(({ id, label }) => (
              <li key={id}>
                <Link
                  to={id}
                  smooth={true}
                  duration={500}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer"
                  style={{ color: styles.colors.grayish }}
                  onMouseEnter={(e) => (e.target.style.color = styles.colors.primary)}
                  onMouseLeave={(e) => (e.target.style.color = styles.colors.grayish)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </header>

      {/* HERO SECTION */}
      <section id="welcome" className="relative min-h-screen pt-[90px] md:pt-[100px] py-24 flex flex-col md:flex-row items-center justify-center overflow-hidden">
        <motion.div className="absolute top-0 bottom-0 left-0 w-[30vw] z-0" style={{ background: styles.gradients.left }} />
        <motion.div className="absolute bottom-[-4rem] right-[-4rem] w-56 h-56 md:w-72 md:h-72 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />
        
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between w-full px-6 md:px-20 max-w-[1600px] mx-auto">
          <motion.div className="md:w-1/2 flex justify-center mb-10 md:mb-0" initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>
            <div className="w-64 h-64 md:w-96 md:h-96 rounded-full overflow-hidden shadow-lg border-4 border-white">
              <img src={heroImage} alt="Team" className="w-full h-full object-cover" />
            </div>
          </motion.div>

          <motion.div className="md:w-1/2 md:pl-12 text-center md:text-left" initial={{ opacity: 0, x: 60 }} whileInView={{ opacity: 1, x: 0 }}>
            <ResponsiveText isTitle text="Benvenuto in OEM TECS Srl!" />
            <ResponsiveText text="Siamo un nuova realtà che produce occhiali in acetato di cellulosa dal design unico e fatti a mano in Italia, offre consulenze personalizzate per far crescere le tue idee e siamo gli esclusivi distributori di Ecopure, un innovativo prodotto in tema di sostenibilità ambientale." />
            <ResponsiveText text="Qui trovi competenza e soluzioni su misura!" />
          </motion.div>
        </div>
      </section>

      {/* MISSION SECTION */}
      <section id="mission" className="relative min-h-screen py-24 flex flex-col md:flex-row items-center justify-center overflow-hidden">
        <motion.div className="absolute top-0 bottom-0 right-0 w-[35vw] z-0" style={{ background: styles.gradients.left }} />
        <motion.div className="absolute bottom-[0rem] left-[-4rem] w-56 h-56 md:w-72 md:h-72 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <div className="relative z-10 flex flex-col-reverse md:flex-row items-center justify-between w-full px-6 md:px-20 max-w-[1600px] mx-auto">
          <motion.div className="md:w-1/2 md:pr-12" initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>
            <ResponsiveText isTitle text="La Nostra Missione" />
            <ResponsiveText text="Noi di OEM TECS non ci limitiamo a fare occhiali: creiamo occhiali in acetato di cellulosa che raccontano una storia, con stile e personalità." />
            <ResponsiveText text="La nostra missione? Portare qualità, innovazione e un tocco di creatività in tutto quello che facciamo!" />

            {[{
              title: "Occhiali unici",
              text: "Creare occhiali unici e pensati per chi vuole distinguersi."
            }, {
              title: "Consulenze su misura",
              text: "Offrire consulenze su misura, perché ogni cliente merita soluzioni che calzano a pennello."
            }, {
              title: "Distribuzione esclusiva",
              text: "Siamo gli esclusivi distributori di AdTerix, un’azienda canadese che condivide la nostra passione per l’eccellenza e la sostenibilità."
            }].map((item, index) => (
              <div className="flex items-start mb-6" key={index}>
                <Ball number={index + 1} />
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2" style={{ fontFamily: styles.fonts.title }}>{item.title}</h3>
                  <p className="text-sm text-gray-700" style={{ fontFamily: styles.fonts.body }}>{item.text}</p>
                </div>
              </div>
            ))}

            <ResponsiveText text="Lavoriamo con entusiasmo e attenzione ai dettagli, mettendo il cliente al centro. Vogliamo costruire relazioni, non solo prodotti, per poter crescere insieme ai nostri partner." />
          </motion.div>

          <motion.div className="md:w-1/2 flex justify-center mb-10 md:mb-0" initial={{ opacity: 0, x: 60 }} whileInView={{ opacity: 1, x: 0 }}>
            <div className="w-72 h-72 md:w-[400px] md:h-[400px] rounded-[40px] overflow-hidden shadow-lg border-4 border-white">
              <img src={missionImage} alt="Mission" className="w-full h-full object-cover" />
            </div>
          </motion.div>
        </div>
      </section>


      {/* SERVICES SECTION */}
      <section id="services" className="relative min-h-screen py-24 px-6 md:px-20 overflow-hidden bg-white flex flex-col justify-center">
        <motion.div className="absolute top-1/3 left-[-4rem] w-60 h-60 md:w-72 md:h-72 rounded-full z-0" style={{ background: styles.gradients.left }} />
        <motion.div className="absolute bottom-0 right-[-3rem] w-40 h-40 md:w-56 md:h-56 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <div className="relative z-10 max-w-[1600px] mx-auto text-center">
          <motion.h2 style={{ fontFamily: styles.fonts.title, fontSize: "2.5rem", marginBottom: "1rem", color: styles.colors.blackish }} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}>I NOSTRI SERVIZI</motion.h2>
          <ResponsiveText text="In OEM TECS Srl mettiamo passione e creatività in tutto quello che facciamo. Scopri come possiamo aiutarti con i nostri servizi su misura!" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20 text-left mt-10">
            {[{
              title: "Occhiali in Acetato di Cellulosa",
              text: "Progettiamo e produciamo occhiali in acetato di cellulosa fatti a mano in Italia. Ogni occhiale è pensato per unire stile, comfort e qualità."
            }, {
              title: "Private label all’ennesima potenza!",
              text: "Che tu voglia un design unico o una collezione personalizzata, siamo pronti a dare forma alla tua visione! Consulta la pagina Private Label per saperne di più."
            }, {
              title: "Consulenze Personalizzate",
              text: "Hai un’idea o un progetto? Parliamone! Offriamo consulenze 3D su misura per aiutarti a sviluppare idee e creare prodotti che fanno la differenza."
            }, {
              title: "Distributori Esclusivi di Ecopure",
              text: "Siamo distributori esclusivi di Ecopure: un additivo per plastiche sinonimo di innovazione e sostenibilità. Scarica la presentazione Ecopure."
            }].map((item, index) => (
              <motion.div key={index} className="flex items-start gap-3 px-2" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: index * 0.1 }}>
                <Ball number={index + 1} />
                <div>
                  <h3 style={{ fontFamily: styles.fonts.title }} className="text-lg font-semibold text-gray-800 mb-1">{item.title}</h3>
                  <p style={{ fontFamily: styles.fonts.body }} className="text-sm text-gray-700 leading-relaxed">{item.text}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((img, index) => (
              <motion.div key={index} className="overflow-hidden rounded-[20px] shadow-lg" initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: index * 0.1 }}>
                <img src={img} alt={`Servizio ${index + 1}`} className="w-full h-[250px] object-cover" />
              </motion.div>
            ))}
          </div>

          <ResponsiveText text="Pronto a iniziare? Contattaci e scopri come possiamo fare squadra insieme!" />
        </div>
      </section>

      {/* VISION SECTION */}
      <section id="vision" className="relative min-h-screen py-24 flex flex-col md:flex-row items-center justify-center overflow-hidden bg-white">
        <motion.div className="absolute top-0 bottom-0 left-0 w-[35vw] z-0" style={{ background: styles.gradients.left }} />
        <motion.div className="absolute bottom-[-4rem] right-[-4rem] w-56 h-56 md:w-72 md:h-72 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between w-full px-6 md:px-20 max-w-[1600px] mx-auto">
          <motion.div className="md:w-1/2 flex justify-center mb-10 md:mb-0" initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>
            <div className="w-72 h-[400px] md:w-[400px] md:h-[500px] rounded-[30px] overflow-hidden shadow-lg border-4 border-white">
              <img src={vision} alt="Vision" className="w-full h-full object-cover" />
            </div>
          </motion.div>

          <motion.div className="md:w-1/2 md:pl-12 text-left" initial={{ opacity: 0, x: 60 }} whileInView={{ opacity: 1, x: 0 }}>
            <ResponsiveText isTitle text="LA NOSTRA VISIONE" />
            <ResponsiveText text="In OEM TECS Srl vogliamo un futuro dove stile, innovazione, sostenibilità e relazioni autentiche si fondono per creare valore." />

            {["Occhiali che raccontano", "Idee che diventano successi", "Impegno sostenibile"].map((title, i) => (
              <div key={i} className="flex items-start mb-6">
                <Ball number={i + 1} />
                <div>
                  <h3 style={{ fontFamily: styles.fonts.title }} className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
                  <ResponsiveText text={
                    i === 0 ? "Essere un punto di riferimento per chi cerca occhiali che raccontano una storia." :
                    i === 1 ? "Offriamo consulenze che trasformano idee in successi concreti." :
                    "Con Ecopure trasformiamo il nostro impegno per un mondo più sostenibile."
                  } />
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* TEAM SECTION */}
      <section id="team" className="relative min-h-screen py-24 flex flex-col justify-center px-6 md:px-20 py-24 bg-white overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1/2 z-0" style={{ background: styles.gradients.sideLeft }} />
        <div className="absolute bottom-[1rem] right-[-4rem] w-60 h-60 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <motion.h2 className="text-4xl md:text-5xl text-center mb-20 z-10" style={{ fontFamily: styles.fonts.title, fontSize: "2.5rem", color: styles.colors.blackish }}>CHI SIAMO</motion.h2>

        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-20 max-w-6xl mx-auto text-center">
          {[{ name: "ENRICO", surname: "DEPPI", img: member1 }, { name: "MIKHAILO", surname: "MYRONIUK", img: member2 }].map((member, i) => (
            <motion.div key={i} className="flex flex-col items-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>
              <div className="w-30 h-30 md:w-52 md:h-52 rounded-full overflow-hidden border-4 border-white shadow-md mb-1">
                <img src={member.img} alt={member.name} className="w-full h-full object-cover object-top scale-110" />
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: styles.fonts.title, color: styles.colors.blackish }}>{member.name}</h3>
              <h4 className="text-xl font-semibold mb-2" style={{ fontFamily: styles.fonts.title, color: styles.colors.blackish }}>{member.surname}</h4>
              <ResponsiveText text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud." />
            </motion.div>
          ))}
        </div>
      </section>

      {/* LABEL SECTION */}
      <section id="label" className="relative min-h-screen px-6 md:px-20 py-24 overflow-hidden bg-white flex flex-col justify-center">
        <div className="absolute bottom-0 left-0 w-full h-1/2 z-0" style={{ background: styles.gradients.sideLeft }} />
        <div className="absolute bottom-[0rem] right-[-4rem] w-56 h-56 bg-blue-200 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <div className="relative z-10 max-w-[1600px] mx-auto w-full">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
            <div className="w-full md:w-1/2 text-left">
              <ResponsiveText isTitle text="PRIVATE LABEL" />
              <ResponsiveText text="Il servizio private label è indirizzato alle ottiche che vogliono creare la loro linea di occhiali esclusivi, attingendo da una vasta gamma di forme, colori e personalizzazioni." />
              <ResponsiveText text="Tutti i nostri occhiali in acetato sono fatti a mano in Cadore, garanzia di qualità e tradizione artigianale." />
              <ResponsiveText text="Contattaci per saperne di più." />
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-end items-center gap-6">
            {clients.map((img, index) => (
              <motion.div key={index} className="w-[260px] h-[300px] bg-white rounded-[20px] shadow-xl overflow-hidden" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.2 * index }}>
                <img src={img} alt={`Private Label ${index + 1}`} className="w-full h-full object-cover" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="relative h-screen flex flex-col md:flex-row items-center justify-center overflow-hidden">
        <motion.div className="absolute top-0 bottom-0 left-0 w-[35vw] z-0" style={{ background: styles.gradients.top }} />
        <motion.div className="absolute bottom-[-4rem] right-[-4rem] w-56 h-56 md:w-72 md:h-72 rounded-full z-0" style={{ backgroundColor: styles.colors.accent }} />

        <div className="relative z-10 w-full px-6 md:px-20 max-w-[1600px] mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
          <motion.div className="md:w-1/2 flex justify-center" initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }}>
            <img src={contact} alt="Team in discussion" className="rounded-[24px] shadow-xl object-cover w-[320px] md:w-[520px] h-auto" />
          </motion.div>

          <motion.div className="md:w-1/2 text-left" initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }}>
            <ResponsiveText isTitle text="CONTATTI" />
            <ResponsiveText text="Che tu voglia scoprire di più sui nostri occhiali, avere una consulenza o parlare della distribuzione di Ecopure, siamo qui per te." />

            {["+123-456-7890", "www.reallygreatsite.com", "hello@reallygreatsite.com", "123 Anywhere ST., Any City, ST 12345"].map((item, i) => (
              <motion.div key={i} className="flex items-center gap-4 hover:text-blue-700 transition duration-300" initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5, delay: i * 0.1 }}>
                <span className="text-blue-700 text-xl">{["📞", "🌐", "✉️", "📍"][i]}</span>
                <ResponsiveText text={item} />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default LandingPage;
